import type { 
  GetPromoCodesData,
  GetPromoCodesResponse,

  PostPromoCodesData,
  PostPromoCodesResponse,

  PutPromoCodesByIdData,
  PutPromoCodesByIdResponse,

  DeletePromoCodesByIdData,
  DeletePromoCodesByIdResponse
 } from "@/types/openapi-ts";

import type { AxiosInstance } from "axios";

export function getPromocodeApiModule(affiliatesApi: AxiosInstance) {
  return {
    getAffiliatePromoCodes(params: GetPromoCodesData['query']) {
      return affiliatesApi.get<GetPromoCodesResponse>('/promo-codes', { params });
    },
    postAffiliatePromoCodes(params: PostPromoCodesData['body']) {
      return affiliatesApi.post<PostPromoCodesResponse>('/promo-codes', params);
    },
    putAffiliatePromoCodes(id: string, params: PutPromoCodesByIdData['body']) {
      return affiliatesApi.put<PutPromoCodesByIdResponse>(`/promo-codes/${id}`, params);
    },
    deleteAffiliatePromoCodes(id: string) {
      return affiliatesApi.delete<DeletePromoCodesByIdResponse>(`/promo-codes/${id}`);
    },
  }
}
